import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "@/assets/css/tailwind.css";
import VueLazyload from 'vue-lazyload'
import VueGtm from 'vue-gtm';


import Default from "./layouts/Default.vue";
import Blank from "./layouts/Blank.vue";

Vue.component("default-layout", Default);
Vue.component("blank-layout", Blank);
Vue.use(VueLazyload);
Vue.use(VueGtm, {
  id: 'GTM-PG9BJX2',
  defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional) 
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
});
 
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
